export default {
  Experiences(state) {
    return state.experiences;
  },
};